<script setup>
import TimeRegistrationsTable from '@/Pages/PartnerSupport/Tickets/Partials/TimeRegistrationsTable.vue';
import { computed } from 'vue';

const props = defineProps({
  service: {
    type: Object,
    required: true,
  },
});

const isTypeHours = computed(() => {
  return props.service.type === 'hours';
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div>
    <div class="p-5 bg-white mx-4">
      <div class="flex">
        <h1 class="h2">
          {{ trans('__JSON__.Paid Service Detail') }}
        </h1>
      </div>
      <div>
        <div class="mt-4 mb-2">
          <strong>{{ trans('__JSON__.Purchase date') }}:</strong>
          <p>{{ moment(service.datePurchased).format('DD/MM/YYYY') }}</p>
        </div>
        <div class="mt-4 mb-2">
          <strong>{{ trans('__JSON__.Status') }}:</strong>
          <p>{{ service.status }}</p>
        </div>

        <div class="mt-4 mb-2">
          <strong>{{ trans('__JSON__.Description') }}:</strong>
          <p>{{ service.description }}</p>
        </div>

        <div v-if="isTypeHours">
          <div class="mt-4 mb-2">
            <strong>{{ trans('__JSON__.Spent hours') }}:</strong>
            <p>{{ service.spentHours }}</p>
          </div>
          <div class="mt-4 mb-2">
            <strong>{{ trans('__JSON__.Remaining hours') }}:</strong>
            <p>{{ service.remainingHours }}</p>
          </div>
        </div>
        <div v-else>
          <div class="mt-4 mb-2">
            <strong>{{ trans('__JSON__.Spent flows') }}:</strong>
            <p>{{ service.spentFlows }}</p>
          </div>
          <div class="mt-4 mb-2">
            <strong>{{ trans('__JSON__.Remaining flows') }}:</strong>
            <p>{{ service.remainingFlows }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isTypeHours" class="my-5 mx-4 p-5 bg-white">
      <div class="flex">
        <h1 class="h2">
          {{ trans('__JSON__.Time registrations') }}
        </h1>
      </div>
      <div>
        <time-registrations-table
          :hidden-columns="['paidServiceId', 'isBillable']"
          :time-registrations="service.billableUsages"
        />
      </div>
    </div>
  </div>
</template>